import React from "react";
import { assets } from "../../../Assets/assets";

const MissionVision = ({ id }) => {
  const missionCards = [
    { img: assets.mv1, label: "Our Mission" },
    { img: assets.mv2, label: "Our Vision" },
    { img: assets.mv3, label: "Our Philosophy" },
    { img: assets.mv4, label: "Our Strategy" },
  ];

  return (
    <section id={id} className="w-full bg-white">
      <div className="max-w-[1400px] mx-auto px-6 xl:py-20 py-14 grid grid-cols-1 lg:grid-cols-2 gap-10">

        <div data-aos="fade-up-right" data-aos-duration="1000" className="grid grid-cols-2 gap-6">

          {missionCards.map((item, index) => (
            <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100}
              key={index} style={{ backgroundImage: `url(${item.img})` }}
              className={`relative ${index === 1 && 'mt-5'} ${index === 2 && '-mt-5'} overflow-hidden h-[180px] md:h-[200px] bg-cover group`}
            >
              {/* <img
                src={item.img}
                alt={item.label}
                className="h-[180px] md:h-[200px] w-full object-cover transition-all duration-500 group-hover:scale-105"
              /> */}
              <div className="bg-[#2B576AB2] h-full w-full"></div>

              <img
                src={assets.vector}
                alt="vector"
                className="absolute top-0 right-0 w-10 md:w-12"
              />

              <p className="absolute inset-0 flex items-center justify-center 
                text-white text-lg md:text-xl group-hover:scale-125 transition-all duration-500 font-semibold tracking-wide">
                {item.label}
              </p>
            </div>
          ))}

        </div>

        <div data-aos="fade-up-left" data-aos-duration="1000" className="space-y-12 text-primaryTextColor">

          <div className="space-y-4 relative">
            <div className="flex items-center gap-3">
              <span className="w-2 h-6 bg-primaryFadedColor"></span>
              <h2 className="text-2xl xl:text-3xl font-semibold font-SpaceGrotesk">
                Our Mission
              </h2>
            </div>

            <p className="text-secondaryTextColor leading-relaxed text-[15px] md:text-[16px]">
              That’s why the highly skilled and dedicated recruitment team at Natio
              Management Services Private Limited works tirelessly to build long-term
              relationships with both candidates and clients. We focus on helping our
              employees achieve their career goals while delivering effective staffing
              solutions tailored to the needs of our clients and candidates.
            </p>

            <img
              src={assets.missionicon}
              alt="mission-icon"
              className="absolute -top-10 right-0 w-14 md:w-20 xl:w-24"
            />
          </div>

          <div className="space-y-4 relative">
            <div className="flex items-center gap-3">
              <span className="w-2 h-6 bg-primaryFadedColor"></span>
              <h2 className="text-2xl xl:text-3xl font-semibold font-SpaceGrotesk">
                Our Vision
              </h2>
            </div>

            <p className="text-secondaryTextColor leading-relaxed text-[15px] md:text-[16px]">
              That’s why the highly skilled and dedicated recruitment team at Natio
              Management Services Private Limited works tirelessly to build long-term
              relationships with both candidates and clients. We focus on helping our
              employees achieve their career goals while delivering effective staffing
              solutions tailored to the needs of our clients and candidates.
            </p>

            <img
              src={assets.visionicon}
              alt="vision-icon"
              className="absolute -top-10 right-0 w-14 md:w-20 xl:w-24"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default MissionVision;
